export type SandboxStatus =
  | "creating"
  | "pending"
  | "active"
  | "failed"
  | "expired";

export const COUNTRIES = ["ae", "sa", "qa", "bh", "eg"] as const;
export type Country = (typeof COUNTRIES)[number];

export const EXPIRY_PERIODS = [30, 60] as const;
export type ExpiryPeriod = (typeof EXPIRY_PERIODS)[number];

export interface Sandbox {
  id: string;
  name: string;
  country: string;
  status: SandboxStatus;
  createdAt: string;
  updatedAt: string;
  expiresAt: string | null;
  credits: number | null;
  lastUsedAt: string | null;
  lastUsedKnown: boolean;
}

export interface SandboxApiKey {
  id: string;
  apiKey: string;
  apiSecret: string;
  createdAt: string;
  expiresAt: string | null;
  scopes?: string[] | null;
}

export interface CreateSandboxInput {
  name: string;
  country: Country;
  expiryPeriodInDays: ExpiryPeriod;
  scopes: string[];
}

export type LeadEntityType = "listing" | "agent";
export type LeadChannel = "whatsapp" | "email" | "call";

export interface LeadTarget {
  id: string;
  label: string;
  meta: string;
}

export interface TestLead {
  id: string;
  publicId: string;
  channel: string;
  status: string;
  createdAt: string;
}

export const LEAD_COMBINATIONS: Record<
  LeadEntityType,
  { leadType: string; channels: LeadChannel[] }
> = {
  listing: { leadType: "property_lead", channels: ["call", "whatsapp", "email"] },
  agent: { leadType: "agent_lead", channels: ["whatsapp"] },
};
